<ng-container [ngSwitch]="inputMode">
    <ng-container *ngSwitchCase="'selectSearch'" [ngSwitch]="arlType$ | async">
        <ng-container *ngSwitchCase="AccountsReceivableLedgerTypeEnum.MaterialArl" [ngTemplateOutlet]="materialSelectSearch"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="defaultSelectSearch"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'pseudoSelectSearch'">
        <ng-container *ngIf="!_entityId; else defaultTextinput">
            <ng-container [ngSwitch]="arlType$ | async">
                <ng-container *ngSwitchCase="AccountsReceivableLedgerTypeEnum.MaterialArl" [ngTemplateOutlet]="materialSelectSearch"></ng-container>
                <ng-container *ngSwitchDefault [ngTemplateOutlet]="defaultSelectSearch"></ng-container>
            </ng-container>
        </ng-container>
    </ng-container>

    <!--    autocomplete -->
    <ng-container *ngSwitchDefault>
        <ng-container [ngSwitch]="arlType$ | async">
            <ng-container *ngSwitchDefault [ngTemplateOutlet]="defaultAutocomplete"></ng-container>
            <ng-container *ngSwitchCase="AccountsReceivableLedgerTypeEnum.MaterialArl" [ngTemplateOutlet]="materialAutocomplete"></ng-container>
        </ng-container>
    </ng-container>
</ng-container>



<ng-template #defaultTextinput>
    <mat-form-field [floatLabel]="floatLabel">
        <input [class]="inputClass" type="text" [placeholder]="placeholder" [attr.aria-label]="placeholder" matInput [formControl]="informationControl" />
    </mat-form-field>
</ng-template>
<ng-template #defaultAutocomplete>
    <mat-form-field [floatLabel]="floatLabel">
        <input [class]="inputClass" type="text" [placeholder]="placeholder" [attr.aria-label]="placeholder" matInput [formControl]="informationControl" [matAutocomplete]="auto" />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onAutocompleteSelected($event)">
            <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option.value" [id]="option.entityId + ''">
                {{ option.optionLabel }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
</ng-template>
<ng-template #materialAutocomplete>
    <mat-form-field [floatLabel]="floatLabel">
        <input type="text" [class]="inputClass" [placeholder]="placeholder" [attr.aria-label]="placeholder" matInput [formControl]="informationControl" (ngModelChange)="materialAutocompleteSearchChange($event, paginator, 'b')" [matAutocomplete]="auto" />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" panelWidth="60%" (opened)="materialPanelOpened(informationControl.value, paginator)">
        <ng-container *ngFor="let option of materialOptions$ | async">
            <mat-optgroup *ngIf="option.childOptions" label="{{ option.optionLabel }}">
                <mat-option *ngFor="let childOption of option.childOptions" [value]="childOption.value"  (onSelectionChange)="onMaterialAutocompleteOptionSelected($event, childOption)">
                    <ng-container *ngTemplateOutlet="materialOptionTemplate; context: { $implicit: childOption }"></ng-container>
                </mat-option>
            </mat-optgroup>
            <mat-option *ngIf="!option.childOptions" [value]="option.value"  (onSelectionChange)="onMaterialAutocompleteOptionSelected($event, option)">
                <ng-container *ngTemplateOutlet="materialOptionTemplate; context: { $implicit: option }"></ng-container>
            </mat-option>
        </ng-container>
        <ng-template #materialOptionTemplate let-option let-isSelected="isSelected">
            {{ option.optionLabel }}
            <fa-icon *ngIf="option.infoTooltip" icon="question-circle" [matTooltip]="option.infoTooltip"></fa-icon>
            <button mat-icon-button *ngIf="isSelected" style="vertical-align: middle; float: right" (click)="$event.preventDefault(); informationControl.reset()">
                <fa-icon icon="times"></fa-icon>
            </button>
        </ng-template>
        <div style="position: sticky; bottom: 0">
            <mat-paginator #paginator [pageSize]="pageSize$ | async" [length]="materialOptionsLength$ | async" (page)="materialOptionsPageChange($event)"></mat-paginator>
        </div>
    </mat-autocomplete>
    </mat-form-field>
</ng-template>
<ng-template #defaultSelectSearch>
    <mat-form-field [floatLabel]="floatLabel">
        <app-select-search
            [placeholder]="placeholder"
            [ngModel]="selectSearchForm.value"
            (ngModelChange)="onDropDownSelected($event)"
            [Options]="options$ | async"
            [CompareOptions]="compareByEntityId"
            [panelClass]="matSelectPanelClass$ | async"
            [disabled]="informationControl.disabled"
        ></app-select-search>
        <fa-icon matSuffix *ngIf="selectSearchForm.value" (click)="onDropDownSelected(null); $event.stopPropagation()" style="margin-left: 3px; cursor: pointer" icon="times"></fa-icon>
    </mat-form-field>
</ng-template>
<ng-template #materialSelectSearch>
    <mat-form-field [floatLabel]="floatLabel">
        <app-select-search-paged-options
            #pagedSelect
            (opened)="materialPanelOpened(pagedSelect.searchForm.value, paginator)"
            [placeholder]="placeholder"
            [ngModel]="selectSearchForm.value"
            (ngModelChange)="onDropDownSelected($event)"
            [Options]="materialOptions$ | async"
            [CompareOptions]="compareMaterialOptions"
            [panelClass]="matSelectPanelClass$ | async"
            [isLoading]="materialsLoading$ | async"
            (searchChange)="materialSearchChange($event, paginator)"
            [triggerTemplate]="materialTriggerTemplate"
            [disabled]="informationControl.disabled"
        >
            <mat-paginator option-list-footer #paginator [pageSize]="pageSize$ | async" [length]="materialOptionsLength$ | async" (page)="materialOptionsPageChange($event)"></mat-paginator>
        </app-select-search-paged-options>
        <fa-icon matSuffix *ngIf="selectSearchForm.value" (click)="onDropDownSelected(null); $event.stopPropagation()" style="margin-left: 3px; cursor: pointer" icon="times"></fa-icon>
    </mat-form-field>
    <ng-template #materialTriggerTemplate>
        {{ selectSearchForm.value?.value }}
    </ng-template>
</ng-template>
